/**
 * Do not edit directly
 * Generated on Fri, 28 Aug 2026 14:37:50 GMT
 */

const theme = {
  colors: {
    border: {
      primary: '#C9CFD4',
      secondary: '#D7DCE0',
      contrast: '#62686E',
      error: '#BC4338',
      caution: '#F8B816',
      success: '#1A824E',
      info: '#C9CFD4',
      highlight: '#1a5e5e',
      input_focus: '#227979',
    },
    brand: {
      rover: '#00BD70',
      catinaflat: '#F4715F',
      folder: '#D9D9D9',
      safety: '#2741CC',
      logo: '#F31E1E',
      facebook: '#3B5998',
      google: '#4285F4',
      instagram: '#8A3AB9',
      linkedin: '#0A66C2',
      tiktok: '#000000',
      youtube: '#FF0000',
      apple: '#000000',
      active_brand: '#4A7C7E',
      whatsapp: '#25D366',
    },
    neutral: {
      '100': '#F4F5F6',
      '200': '#E6E8EB',
      '300': '#D7DCE0',
      '400': '#C9CFD4',
      '500': '#9EA5AC',
      '600': '#767C82',
      '700': '#62686E',
      '800': '#404347',
      '900': '#1F2124',
      white: '#FFFFFF',
      black: '#000000',
    },
    green: {
      '100': '#F1FDF6',
      '200': '#BAE8C9',
      '300': '#6BD094',
      '400': '#05B86C',
      '500': '#169A5B',
      '600': '#1A824E',
      '700': '#1B6C42',
      '800': '#1B5535',
      '900': '#173724',
    },
    cyan: {
      '100': '#E8F9FC',
      '200': '#8BE2EF',
      '300': '#39CDE4',
      '400': '#1CB0C7',
      '500': '#1893A7',
      '600': '#127787',
      '700': '#116876',
      '800': '#0D535D',
      '900': '#09363D',
    },
    yellow: {
      '100': '#FCF6EB',
      '200': '#FFECBD',
      '300': '#FFD76A',
      '400': '#F8B816',
      '500': '#D59418',
      '600': '#B77F1D',
      '700': '#80561A',
      '800': '#654418',
      '900': '#412C13',
    },
    blue: {
      '100': '#ECF1FB',
      '200': '#C5D5F2',
      '300': '#A3BDEB',
      '400': '#7DA1E2',
      '500': '#5685DA',
      '600': '#2E67D1',
      '700': '#2D5CB1',
      '800': '#24498C',
      '900': '#172F5B',
    },
    red: {
      '100': '#FFEDE8',
      '200': '#FFC8BC',
      '300': '#FFA494',
      '400': '#FF7665',
      '500': '#E6564A',
      '600': '#BC4338',
      '700': '#A03F37',
      '800': '#7D342D',
      '900': '#4F231F',
    },
    orange: {
      '100': '#FCF5EF',
      '200': '#FFD4A8',
      '300': '#FFA96E',
      '400': '#FF8A46',
      '500': '#FF7525',
      '600': '#E0621B',
      '700': '#BB4F12',
      '800': '#77320B',
      '900': '#331706',
    },
    pink: {
      '100': '#FFF2F7',
      '200': '#FFD6E8',
      '300': '#FFA6CC',
      '400': '#FF7DB1',
      '500': '#FF66A3',
      '600': '#D13880',
      '700': '#99215F',
      '800': '#661342',
      '900': '#330A22',
    },
    overlay: {
      background: 'rgba(31, 33, 36, 0.48)',
      accent: 'rgba(22, 154, 91, 0.24)',
    },
    interactive_text: {
      primary_base: '#404347',
      primary_active: '#227979',
      primary_pressed: '#2D5CB1',
      destructive_base: '#BC4338',
      destructive_pressed: '#A03F37',
      destructive_inverse_base: '#FF7665',
      destructive_inverse_pressed: '#FFA494',
      disabled: '#9EA5AC',
    },
    interactive_link: {
      primary_base: '#227979',
      primary_pressed: '#1a5e5e',
      primary_visited: '#227979',
      primary_inverse_base: '#E9F2F2',
      primary_inverse_pressed: '#F0FAFA',
      primary_inverse_visited: '#E9F2F2',
      secondary_base: '#62686E',
      secondary_pressed: '#1F2124',
      secondary_visited: '#62686E',
      secondary_inverse_base: '#F4F5F6',
      secondary_inverse_pressed: '#D7DCE0',
      secondary_inverse_visited: '#F4F5F6',
    },
    interactive_border: {
      primary_base: '#C9CFD4',
      primary_pressed: '#767C82',
      primary_active: '#227979',
      primary_active_pressed: '#1a5e5e',
      selected: '#2E67D1',
      disabled: '#E6E8EB',
      button_primary_base: '#767C82',
    },
    separator: {
      primary: '#D7DCE0',
    },
    text: {
      primary: '#1F2124',
      primary_inverse: '#FFFFFF',
      secondary: '#404347',
      secondary_inverse: '#F4F5F6',
      tertiary: '#62686E',
      tertiary_inverse: '#E6E8EB',
      display: '#1F2124',
      price: '#1B6C42',
      error: '#BC4338',
      caution: '#654418',
      success: '#1B6C42',
      navigation: '#62686E',
      attention: '#BB4F12',
      attention_highlight: '#F8B816',
      navigation_hover: '#1F2124',
      disabled: '#9EA5AC',
      placeholder: '#62686E',
    },
    teal: {
      '100': '#F0FAFA',
      '200': '#E9F2F2',
      '300': '#C0DADA',
      '400': '#8FBFBF',
      '500': '#5A9E9E',
      '600': '#3A8A8A',
      '700': '#227979',
      '800': '#1a5e5e',
      '900': '#0f3d3d',
    },
  },
  background: {
    primary: '#FFFFFF',
    secondary: '#F4F5F6',
    tertiary: '#E6E8EB',
    contrast: '#404347',
    accent: '#FCF6EB',
    accent_secondary: '#E9F2F2',
    error: '#FFEDE8',
    caution: '#FCF6EB',
    success: '#F1FDF6',
    info: '#ECF1FB',
    highlight: '#E8F9FC',
    attention_blue: '#C5D5F2',
    attention_highlight: '#F8B816',
    navigation: '#FFFFFF',
    overlay: 'rgba(31, 33, 36, 0.48)',
    overlay_accent: 'rgba(22, 154, 91, 0.24)',
    interactive: {
      primary_base: '#FFFFFF',
      primary_pressed: '#F4F5F6',
      primary_active: '#404347',
      primary_active_pressed: '#1F2124',
      disabled: '#F4F5F6',
      destructive: '#BC4338',
      destructive_pressed: '#A03F37',
      button_primary_base: '#227979',
      button_primary_pressed: '#1a5e5e',
      button_primary_inverse_base: '#E9F2F2',
      button_primary_inverse_pressed: '#C0DADA',
      toggle_button_selected_base: '#ECF1FB',
      toggle_button_selected_hover: '#C5D5F2',
    },
  },
  space: {
    '-64x': '-256px',
    '-48x': '-192px',
    '-40x': '-160px',
    '-32x': '-128px',
    '-24x': '-96px',
    '-20x': '-80px',
    '-16x': '-64px',
    '-12x': '-48px',
    '-10x': '-40px',
    '-8x': '-32px',
    '-6x': '-24px',
    '-5x': '-20px',
    '-4x': '-16px',
    '-3x': '-12px',
    '-2x': '-8px',
    '-1x': '-4px',
    '0x': '0px',
    '1x': '4px',
    '2x': '8px',
    '3x': '12px',
    '4x': '16px',
    '5x': '20px',
    '6x': '24px',
    '8x': '32px',
    '10x': '40px',
    '12x': '48px',
    '16x': '64px',
    '20x': '80px',
    '24x': '96px',
    '32x': '128px',
    '40x': '160px',
    '48x': '192px',
    '64x': '256px',
  },
  sizes: {
    '-64x': '-256px',
    '-48x': '-192px',
    '-40x': '-160px',
    '-32x': '-128px',
    '-24x': '-96px',
    '-20x': '-80px',
    '-16x': '-64px',
    '-12x': '-48px',
    '-10x': '-40px',
    '-8x': '-32px',
    '-6x': '-24px',
    '-5x': '-20px',
    '-4x': '-16px',
    '-3x': '-12px',
    '-2x': '-8px',
    '-1x': '-4px',
    '0x': '0px',
    '1x': '4px',
    '2x': '8px',
    '3x': '12px',
    '4x': '16px',
    '5x': '20px',
    '6x': '24px',
    '8x': '32px',
    '10x': '40px',
    '12x': '48px',
    '16x': '64px',
    '20x': '80px',
    '24x': '96px',
    '32x': '128px',
    '40x': '160px',
    '48x': '192px',
    '64x': '256px',
  },
  radii: {
    square: '0px',
    primary: '8px',
    secondary: '4px',
    large: '16px',
    round: '99999px',
  },
  borderWidth: {
    primary: '2px',
    secondary: '1px',
  },
  shadows: {
    elevation_low: '0px 1px 4px 0px rgba(27, 31, 35, 0.24)',
    elevation_mid: '0px 2px 12px -1px rgba(27, 31, 35, 0.24)',
    elevation_high: '0px 8px 10px -6px rgba(27, 31, 35, 0.22)',
    border_primary: '0px 0px 0px 2px rgba(207, 215, 222, 1)',
    border_contrast: '0px 0px 0px 2px rgba(102, 114, 127, 1)',
    border_disabled: '0px 0px 0px 2px rgba(232, 235, 237, 1)',
  },
  fontWeight: {
    regular: '400 !important',
    semibold: '600 !important',
  },
  textColor: {
    primary: '#1F2124',
    primary_inverse: '#FFFFFF',
    secondary: '#404347',
    secondary_inverse: '#F4F5F6',
    tertiary: '#62686E',
    tertiary_inverse: '#E6E8EB',
    display: '#1F2124',
    price: '#1B6C42',
    error: '#BC4338',
    caution: '#654418',
    success: '#1B6C42',
    navigation: '#62686E',
    attention: '#BB4F12',
    attention_highlight: '#F8B816',
    navigation_hover: '#1F2124',
    disabled: '#9EA5AC',
    placeholder: '#62686E',
  },
  textAlign: {
    left: 'left',
    center: 'center',
    right: 'right',
  },
  textDecoration: {
    none: 'none',
    underline: 'underline',
    'line-through': 'line-through',
  },
  textTransform: {
    none: 'none',
    uppercase: 'uppercase',
  },
  variants: {
    card_default: {
      padding: '5x',
      boxShadow: 'elevation_mid',
      borderRadius: 'primary',
    },
    elevation_low: {
      boxShadow: 'elevation_low',
    },
    elevation_mid: {
      boxShadow: 'elevation_mid',
    },
    elevation_high: {
      boxShadow: 'elevation_high',
    },
  },
  buttons: {
    base: {
      borderRadius: 'round',
      borderWidth: '2px',
      borderColor: 'transparent',
      borderStyle: 'solid',
      cursor: 'pointer',
      bg: 'transparent',
      '-webkit-font-smoothing': 'antialiased',
      '-moz-osx-font-smoothing': 'antialiased',
      '&:hover,&:active': {
        textDecoration: 'none',
      },
    },
    disabled: {
      variant: 'buttons.base',
      color: '#9EA5AC',
      background: 'interactive.disabled',
      borderColor: 'interactive_border.disabled',
      cursor: 'not-allowed',
      '&:hover,&:active': {
        color: '#9EA5AC',
      },
    },
    secondary: {
      base: {
        variant: 'buttons.base',
        color: '#404347',
        background: 'interactive.primary_base',
        borderColor: 'interactive_border.button_primary_base',
        '&:hover,&:active': {
          color: '#404347',
          background: 'interactive.primary_pressed',
        },
      },
      contrast: {
        variant: 'buttons.base',
        color: '#FFFFFF',
        background: 'contrast',
        borderColor: 'border.contrast',
        '&:hover,&:active': {
          color: '#FFFFFF',
          backgroundColor: 'neutral.900',
        },
      },
      destructive: {
        variant: 'buttons.secondary.base',
        color: '#BC4338',
        borderColor: 'border.error',
        '&:hover,&:active': {
          color: '#BC4338',
          background: 'error',
        },
      },
      contrastDestructive: {
        variant: 'buttons.base',
        color: 'interactive_text.destructive_inverse_base',
        borderColor: 'border.error',
        '&:hover,&:active': {
          color: 'interactive_text.destructive_inverse_pressed',
          backgroundColor: '#4F231F',
        },
      },
    },
    primary: {
      base: {
        variant: 'buttons.base',
        color: '#FFFFFF',
        background: 'interactive.button_primary_base',
        boxShadow: 'elevation_mid',
        '&:hover,&:active': {
          color: '#FFFFFF',
          background: 'interactive.button_primary_pressed',
        },
      },
      contrast: {
        variant: 'buttons.base',
        color: '#FFFFFF',
        background: 'interactive.button_primary_base',
        boxShadow: 'elevation_mid',
        '&:hover,&:active': {
          color: '#FFFFFF',
          background: 'interactive.button_primary_pressed',
        },
      },
      destructive: {
        variant: 'buttons.base',
        color: '#FFFFFF',
        background: 'interactive.destructive',
        boxShadow: 'elevation_mid',
        '&:hover,&:active': {
          color: '#FFFFFF',
          background: 'interactive.destructive_pressed',
        },
      },
      contrastDestructive: {
        variant: 'buttons.base',
        color: '#FFFFFF',
        background: 'interactive.destructive',
        boxShadow: 'elevation_mid',
        '&:hover,&:active': {
          color: '#FFFFFF',
          background: 'interactive.destructive_pressed',
        },
      },
    },
    flat: {
      base: {
        variant: 'buttons.base',
        color: 'interactive_link.primary_base',
        '&:hover,&:active': {
          color: 'interactive_link.primary_pressed',
          background: 'interactive.primary_pressed',
        },
      },
      contrast: {
        variant: 'buttons.base',
        color: '#FFFFFF',
        '&:hover,&:active': {
          color: '#FFFFFF',
          backgroundColor: 'neutral.900',
        },
      },
      destructive: {
        variant: 'buttons.base',
        color: '#BC4338',
        '&:hover,&:active': {
          color: '#BC4338',
          backgroundColor: '#FFEDE8',
        },
      },
      contrastDestructive: {
        variant: 'buttons.base',
        color: 'interactive_text.destructive_inverse_base',
        '&:hover,&:active': {
          color: 'interactive_text.destructive_inverse_pressed',
          backgroundColor: '#4F231F',
        },
      },
    },
    link: {
      base: {
        variant: 'buttons.base',
        color: 'interactive_link.primary_base',
        borderColor: 'transparent',
        borderWidth: '0',
        borderRadius: '0',
        display: 'inline',
        textDecoration: 'underline',
        '&:hover,&:active': {
          color: 'interactive_link.primary_pressed',
        },
      },
      contrast: {
        variant: 'buttons.link.base',
        color: 'interactive_link.primary_inverse_base',
        '&:hover,&:active': {
          color: 'interactive_link.primary_inverse_pressed',
        },
      },
      destructive: {
        variant: 'buttons.link.base',
        color: 'interactive_text.destructive_base',
        '&:hover,&:active': {
          color: 'interactive_text.destructive_pressed',
        },
      },
      contrastDestructive: {
        variant: 'buttons.link.base',
        color: 'interactive_text.destructive_inverse_base',
        '&:hover,&:active': {
          color: 'interactive_text.destructive_inverse_pressed',
        },
      },
    },
    link_disabled: {
      variant: 'buttons.link.base',
      color: 'interactive_text.disabled',
      cursor: 'not-allowed',
      '&:hover,&:active': {
        color: 'interactive_text.disabled',
      },
    },
  },
  text: {
    '50': {
      fontSize: '13px',
      fontWeight: 400,
      lineHeight: 1.25,
    },
    '100': {
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: 1.25,
    },
    '200': {
      fontSize: '16px',
      fontWeight: 400,
      lineHeight: 1.5,
    },
    '300': {
      fontSize: '20px',
      fontWeight: 400,
      lineHeight: 1.2,
    },
  },
  paragraph: {
    '50': {
      fontSize: '13px',
      fontWeight: 400,
      lineHeight: 1.5,
      marginBottom: '12px',
    },
    '100': {
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: 1.5,
      marginBottom: '12px',
    },
    '200': {
      fontSize: '16px',
      fontWeight: 400,
      lineHeight: 1.5,
      marginBottom: '16px',
    },
    '300': {
      fontSize: '20px',
      fontWeight: 400,
      lineHeight: 1.5,
      marginBottom: '24px',
    },
  },
  heading: {
    '50': {
      fontSize: '13px',
      fontWeight: 600,
      lineHeight: 1.25,
      marginBottom: '8px',
    },
    '100': {
      fontSize: '14px',
      fontWeight: 600,
      lineHeight: 1.25,
      marginBottom: '8px',
    },
    '200': {
      fontSize: '16px',
      fontWeight: 600,
      lineHeight: 1.25,
      marginBottom: '12px',
    },
    '300': {
      fontSize: '20px',
      fontWeight: 600,
      lineHeight: 1.25,
      marginBottom: '16px',
    },
    '400': {
      fontSize: '26px',
      fontWeight: 600,
      lineHeight: 1.25,
      marginBottom: '20px',
    },
    '500': {
      fontSize: '32px',
      fontWeight: 600,
      lineHeight: 1.25,
      marginBottom: '24px',
    },
    '600': {
      fontSize: '38px',
      fontWeight: 600,
      lineHeight: 1.25,
      marginBottom: '32px',
    },
  },
  headingResponsive: {
    '400': {
      fontSize: '32px',
    },
    '500': {
      fontSize: '40px',
    },
    '600': {
      fontSize: '48px',
    },
  },
  display: {
    '400': {
      fontFamily: 'Recoleta',
      fontSize: '26px',
      fontWeight: 600,
      lineHeight: 1.25,
      marginBottom: '20px',
    },
    '500': {
      fontFamily: 'Recoleta',
      fontSize: '32px',
      fontWeight: 600,
      lineHeight: 1.25,
      marginBottom: '24px',
    },
    '600': {
      fontFamily: 'Recoleta',
      fontSize: '38px',
      fontWeight: 600,
      lineHeight: 1.25,
      marginBottom: '32px',
    },
  },
  displayResponsive: {
    '400': {
      fontSize: '32px',
    },
    '500': {
      fontSize: '40px',
    },
    '600': {
      fontSize: '48px',
    },
  },
};

export default theme;

/** The entire theme object. */
export type Theme = typeof theme;

/** Theme color tokens organized by category */
export type Colors = Theme['colors'];
/** Theme background tokens */
export type Background = Theme['background'];
/** Union of all available background color keys from theme */
export type BackgroundColors =
  | 'primary'
  | 'secondary'
  | 'tertiary'
  | 'contrast'
  | 'accent'
  | 'accent_secondary'
  | 'error'
  | 'caution'
  | 'success'
  | 'info'
  | 'highlight'
  | 'attention_blue'
  | 'attention_highlight'
  | 'navigation'
  | 'overlay'
  | 'overlay_accent'
  | 'interactive.primary_base'
  | 'interactive.primary_pressed'
  | 'interactive.primary_active'
  | 'interactive.primary_active_pressed'
  | 'interactive.disabled'
  | 'interactive.destructive'
  | 'interactive.destructive_pressed'
  | 'interactive.button_primary_base'
  | 'interactive.button_primary_pressed'
  | 'interactive.button_primary_inverse_base'
  | 'interactive.button_primary_inverse_pressed'
  | 'interactive.toggle_button_selected_base'
  | 'interactive.toggle_button_selected_hover';
/** Interactive state background color keys (hover, active, disabled, etc.) */
export type InteractiveBackgroundColors = keyof Theme['background']['interactive'];
/** Theme spacing tokens ('1x', '2x', etc.) */
export type Spacing = keyof Theme['space'];
/** Theme border radius tokens */
export type Radii = keyof Theme['radii'];
/** Theme font weight tokens */
export type FontWeight = keyof Theme['fontWeight'];
/** Theme text alignment values */
export type TextAlign = keyof Theme['textAlign'];
/** Theme text color tokens */
export type TextColor = keyof Theme['textColor'];
/** Theme text decoration values */
export type TextDecoration = keyof Theme['textDecoration'];
/** Theme text transform values */
export type TextTransform = keyof Theme['textTransform'];
export const HEADING_SIZES = ['50', '100', '200', '300', '400', '500', '600'];
/** Theme heading size tokens (50, 100, 200, 300, 400, 500, or 600) */
export type HeadingSizes = (typeof HEADING_SIZES)[number];
export const RESPONSIVE_HEADING_SIZES = ['400', '500', '600'];
/** Theme responsive heading size tokens */
export type ResponsiveHeadingSizes = (typeof RESPONSIVE_HEADING_SIZES)[number];
export const DISPLAY_SIZES = ['400', '500', '600'];
/** Theme display size tokens (400, 500, or 600) */
export type DisplaySizes = (typeof DISPLAY_SIZES)[number];
export const RESPONSIVE_DISPLAY_SIZES = ['400', '500', '600'];
/** Theme responsive display size tokens */
export type ResponsiveDisplaySizes = (typeof RESPONSIVE_DISPLAY_SIZES)[number];
export const PARAGRAPH_SIZES = ['50', '100', '200', '300'];
/** Theme paragraph size tokens (50, 100, 200, or 300) */
export type ParagraphSizes = (typeof PARAGRAPH_SIZES)[number];
export const TEXT_SIZES = ['50', '100', '200', '300'];
/** Theme text size tokens (50, 100, 200, or 300) */
export type TextSizes = (typeof TEXT_SIZES)[number];
